// Uses a ray casting algo to determine if a 2d point is within a polygon: https://en.wikipedia.org/wiki/Point_in_polygon#Ray_casting_algorithm
// NOTE: This only works if the polygon points are in sequential order (either clockwise or counter clockwise)
const isPointInPolygon = ({
  point,
  polygon
}) => {
  let isInsidePolygon = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const currentPolygonPoint = polygon[i];
    const previousPolygonPoint = polygon[j];
    if (currentPolygonPoint.y >= point.y !== previousPolygonPoint.y >= point.y && point.x <= (previousPolygonPoint.x - currentPolygonPoint.x) * (point.y - currentPolygonPoint.y) / (previousPolygonPoint.y - currentPolygonPoint.y) + currentPolygonPoint.x) {
      isInsidePolygon = !isInsidePolygon;
    }
  }
  return isInsidePolygon;
};
export default isPointInPolygon;